import React, { Fragment, useEffect, useState } from 'react';
import {
  Row,
  CardBody,
  Card,
  Button,
  ButtonGroup,
  CustomInput,
  Input,
} from 'reactstrap';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  Separator,
  Colxx,
} from '../../../../../../components/common/CustomBootstrap';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import Languages from '../../../../../../data/languages';
import { gAPI_QuestionSets } from '../../../../../../constants/APIs';
import { useSelector } from 'react-redux';

function Features({
  botSettings,
  saveIntegration,
  integration,
  integrationProperties,
  locale,
  allProperties,
}) {
  const propertyId = useSelector((state) => state?.settings?.propertyId);
  const [formatedProperties, setFormatedProperties] = useState([]);
  const [features, setFeatures] = useState(botSettings.features);
  const [languageGPT3, setLanguageGPT3] = useState([]);
  const [assistantList, setAssistantList] = useState([]);
  const [aiAssistant, setAIAssistant] = useState(
    features.openAIAssistant?.assistantId
      ? features.openAIAssistant?.assistantId
      : ''
  );
  const [selectedProperty, setSelectedProperty] = useState(
    integrationProperties.length > 0 ? integrationProperties[0] : ''
  );
  useEffect(() => {
    const result = integrationProperties.map((id) => {
      return allProperties.find((elem) => elem.id === id);
    });
    setFormatedProperties(result);
  }, [integrationProperties, allProperties]);
  const handleChange = (event) => {
    setSelectedProperty(event.target.value);
  };
  useEffect(() => {
    const languageList = Languages.map((elem) => {
      elem.checked = false;
      botSettings.features.languageGPT3.forEach((lang) => {
        if (lang === elem.code) {
          elem.checked = true;
        }
      });
      return elem;
    });

    setLanguageGPT3(languageList);
  }, [botSettings]);
  useEffect(() => {
    if (selectedProperty) {
      loadResponse();
    }
  }, [selectedProperty]);

  //by default Gpt version
  useEffect(() => {
    if (!features.versionGPT3) {
      setFeatures((prev) => ({
        ...prev,
        versionGPT3: '7',
      }));
    }
  }, []);
  // openAI

  const loadResponse = async () => {
    return await AxiosAPI({
      methed: 'get',
      url: `${gAPI_QuestionSets}/?propertyId=${selectedProperty}&groupId=${getGroupID()}&lang=${locale}`,
    })
      .then((res) => {
        var setslist = res.data.sets.sort(
          (a, b) => a.displayOrder - b.displayOrder
        );
        var list = [];
        if (setslist !== null && setslist.length > 0) {
          setslist
            .filter(
              (l) =>
                l.type === 'DynamicConversationFlow' &&
                l.openAiAssistantId !== ''
            )
            .map((l) => {
              list.push({
                id: l.openAiAssistantId,
                name: l.name,
                isGroupLevel: l?.isGroupVisible ?? false,
              });
            });
        }
        setAssistantList(list);
      })
      .catch((err) => {
        console.error(
          'API error:',
          err.response ? err.response.data : err.message
        );
      });
  };
  //e.o.OpenAI
  const handleCheckedOpenAIEnabled = (e) => {
    const feat = { ...features };
    feat.fixedResponses = false;
    feat.generativeGPT3 = false;

    const openai = { ...feat.openAIAssistant };
    openai.isEnabled = e;
    openai.versionDynamicFlow = e ? '6DynamicConverstionFlow' : '';

    feat.openAIAssistant = openai;
    setFeatures(feat);
  };

  // const handleCheckedOpenAIEnabled = (e) => {
  //   var feat = { ...features };
  //   feat.fixedResponses = false;
  //   feat.generativeGPT3 = false;
  //   var openai = { ...feat.openAIAssistant };
  //   openai.isEnabled = e;
  //   feat.openAIAssistant = openai;
  //   setFeatures(feat);
  // };
  const handleChangeAssistantId = (e) => {
    setAIAssistant(e.target.value);
    var feat = { ...features };
    var openai = { ...feat.openAIAssistant };
    openai.assistantId = e.target.value;
    feat.openAIAssistant = openai;
    setFeatures(feat);
  };

  // const handleVersionDynamicFlowChange = (e) => {
  //   var feat = { ...features };
  //   var openai = { ...feat.openAIAssistant };
  //   openai.versionDynamicFlow = e;
  //   feat.openAIAssistant = openai;
  //   setFeatures(feat);
  // };
  const handleCheckedSerach = (e) => {
    var feat = { ...features };
    feat.predictiveSearch = e;
    setFeatures(feat);
    botSettings.features = feat;
    setTimeout(() => {
      NotificationManager.success(
        '',
        e === true
          ? 'Predictive search enabled successfully'
          : 'Predictive search disabled successfully',
        3000,
        null,
        null,
        'success'
      );
    }, 100);
    saveIntegration({ botSetting: botSettings });
  };
  const handleCheckedUpsells = (e) => {
    var feat = { ...features };
    feat.addOnUpsells = e;
    setFeatures(feat);
    botSettings.features = feat;
    setTimeout(() => {
      NotificationManager.success(
        '',
        e === true
          ? 'Add-on`s & upsells enabled successfully'
          : 'Add-on`s & upsells disabled successfully',
        3000,
        null,
        null,
        'success'
      );
    }, 100);
    saveIntegration({ botSetting: botSettings });
  };
  const handleCheckedFixedResponses = (e) => {
    var feat = { ...features };
    feat.generativeGPT3 = false;
    feat.fixedResponses = e;
    feat.liveChatOnly = e === true ? false : true;
    var openai = { ...feat.openAIAssistant };
    openai.isEnabled = false;
    feat.openAIAssistant = openai;
    setFeatures(feat);
    // botSettings.features = feat;
    // setTimeout(() => {
    //   NotificationManager.success(
    //     '',
    //     e === true
    //       ? 'Fixed Responses enabled successfully'
    //       : 'Fixed Responses disabled successfully',
    //     3000,
    //     null,
    //     null,
    //     'success'
    //   );
    // }, 100);
    // saveIntegration({ botSetting: botSettings });
  };
  const handleCheckedGenerativeGTP3 = (e) => {
    var feat = { ...features };
    feat.fixedResponses = false;
    feat.generativeGPT3 = e;
    feat.liveChatOnly = e === true ? false : true;
    var openai = { ...feat.openAIAssistant };
    openai.isEnabled = false;
    feat.openAIAssistant = openai;
    setFeatures(feat);
    // botSettings.features = feat;
    // setTimeout(() => {
    //   NotificationManager.success(
    //     '',
    //     e === true
    //       ? 'Generative GTP3 enabled successfully'
    //       : 'Generative GTP3 disabled successfully',
    //     3000,
    //     null,
    //     null,
    //     'success'
    //   );
    // }, 100);
    // saveIntegration({ botSetting: botSettings });
  };
  const handleCheckedGenerativeChatGTP = (e) => {
    var feat = { ...features };
    feat.fixedResponses = false;
    feat.generativeGPT3 = false;
    feat.generativeChatGPT = e;
    feat.liveChatOnly = e === true ? false : true;
    var openai = { ...feat.openAIAssistant };
    openai.isEnabled = false;
    feat.openAIAssistant = openai;
    setFeatures(feat);
    // botSettings.features = feat;
    // setTimeout(() => {
    //   NotificationManager.success(
    //     '',
    //     e === true
    //       ? 'Generative ChatGTP enabled successfully'
    //       : 'Generative ChatGTP disabled successfully',
    //     3000,
    //     null,
    //     null,
    //     'success'
    //   );
    // }, 100);
    // saveIntegration({ botSetting: botSettings });
  };
  const handleAutoLanguageDetection = (e) => {
    var feat = { ...features };
    feat.autoLanguageDetection = e;
    setFeatures(feat);
    botSettings.features = feat;
    setTimeout(() => {
      NotificationManager.success(
        '',
        e === true
          ? 'Auto language detection enabled successfully'
          : 'Auto language detection disabled successfully',
        3000,
        null,
        null,
        'success'
      );
    }, 100);
    saveIntegration({ botSetting: botSettings });
  };

  const handleLanguageChange = (e) => {
    const values = languageGPT3.map((elem) => {
      if (elem.code === e.target.value) {
        elem.checked = !elem.checked;
      }
      return {
        ...elem,
      };
    });
    setLanguageGPT3(values);
    const langArr = values
      .filter((elem) => elem.checked === true)
      .map((elem) => elem.code);
    setFeatures({ ...features, languageGPT3: langArr });
  };
  const handleVersionGPT3Change = (e) => {
    var feat = { ...features };
    feat.versionGPT3 = e;
    if (e === '7') {
      feat.reasoningEfforts = 'minimal';
    }
    setFeatures(feat);
  };
  // const handleReasoningEffortsChange = (e) => {
  //   var feat = { ...features };
  //   feat.reasoningEfforts = e;
  //   setFeatures(feat);
  // };
  const handleVerbosityChange = (e) => {
    var feat = { ...features };
    feat.verbosity = e;
    setFeatures(feat);
  };
  const handleSave = () => {
    features.reasoningEfforts = 'minimal';
    botSettings.features = features;
    setTimeout(() => {
      NotificationManager.success(
        '',
        'Features Saved!!',
        3000,
        null,
        null,
        'success'
      );
    }, 100);
    console.log('feature', botSettings);
    saveIntegration({ botSetting: botSettings });
  };
  const handleCheckedLiveChatOnly = (e) => {
    var feat = { ...features };
    feat.generativeGPT3 = e === true ? false : true;
    feat.fixedResponses = e === true ? false : true;
    feat.liveChatOnly = e;
    var openai = { ...feat.openAIAssistant };
    openai.isEnabled = false;
    feat.openAIAssistant = openai;
    setFeatures(feat);
    botSettings.features = feat;
    setTimeout(() => {
      NotificationManager.success(
        '',
        e === true
          ? 'Live Chat Only enabled successfully'
          : 'Live Chat Only disabled successfully',
        3000,
        null,
        null,
        'success'
      );
    }, 100);
    saveIntegration({ botSetting: botSettings });
  };

  const assistantRecord = assistantList?.find(
    (assist) => assist?.id == aiAssistant
  );

  const isNavigateToConversationFlow =
    assistantRecord?.isGroupLevel == true
      ? propertyId == '-1'
      : propertyId != '-1';

  return (
    <Fragment>
      <Card className="mb-4">
        <CardBody>
          <div className="text-center mb-2">
            <h6>Features</h6>
          </div>
          <Separator className="mb-3" />
          <Card className="m-4 p-4">
            <Colxx xxs="12" className="px-0">
              {/*<div className="d-flex w-100">
                <h6 style={{ marginTop: '0.15rem' }}>Predictive search</h6>
                <Switch
                  className="agentswitch  custom-switch-primary custom-switch-small ml-2"
                  checked={features.predictiveSearch}
                  name='predictiveSearch'
                  onChange={(e) => handleCheckedSerach(e)}
                />
              </div>
              <div className="mt-1">
                <p className="m-2">When enabled, user will see predictive suggestions as they type the message</p>
              </div>
              <div className="d-flex w-100">
                <h6 style={{ marginTop: '0.15rem' }}>Add-on's & upsells</h6>
                <Switch
                  className="agentswitch  custom-switch-primary custom-switch-small ml-2"
                  checked={features.addOnUpsells}
                  name='enabled'
                  onChange={(e) => handleCheckedUpsells(e)}
                />
              </div>
             <div className="mt-1">
                <p className="m-2">When enabled, guests will be shown the Add-on and upsell options available</p>
              </div> */}
              <div className="d-flex w-100">
                <h6 style={{ marginTop: '0.15rem' }}>Auto language detection</h6>
                <Switch
                  className="agentswitch  custom-switch-primary custom-switch-small ml-2"
                  checked={features.autoLanguageDetection}
                  name="enabled"
                  onChange={(e) => handleAutoLanguageDetection(e)}
                />
              </div>
              <div className="mt-1">
                <p className="mb-2">
                  When enabled, the language will be auto detected based on the
                  first two messages guest sends. Rest of the conversation will be
                  in that language.
                </p>
              </div>
              <div className="mt-3">
                <h6 style={{ marginTop: '0.15rem' }}>Choose your NLP </h6>
                <div className="d-flex mt-2">
                  <b style={{ marginTop: '0.15rem' }}>Live Chat Only (No AI)</b>
                  <Switch
                    className="agentswitch custom-switch-primary custom-switch-small ml-2"
                    checked={features.liveChatOnly}
                    name="liveChatOnly"
                    onChange={(e) => handleCheckedLiveChatOnly(e)}
                  />
                </div>
                <p className="my-2">
                  Conversations are forwarded to Live Chat agents directly.{' '}
                </p>
                {/* <div className="d-flex mt-2">
                  <b style={{ marginTop: '0.15rem' }}>Fixed Responses</b>
                  <Switch
                    className="agentswitch custom-switch-primary custom-switch-small ml-2"
                    checked={features.fixedResponses}
                    name="fixedResponses"
                    onChange={(e) => handleCheckedFixedResponses(e)}
                  />
                </div> */}
                <div className="d-flex mt-2">
                  <b style={{ marginTop: '0.15rem' }}>Gen AI</b>
                  <Switch
                    className="agentswitch custom-switch-primary custom-switch-small ml-2"
                    checked={features.generativeGPT3}
                    name="generativeGPT3"
                    onChange={(e) => handleCheckedGenerativeGTP3(e)}
                  />
                </div>
                <p className="my-2">
                  Gen AI excels at answering questions by using your Knowledge Hub
                  to provide accurate and relevant information.
                </p>
                <div className="d-flex mt-2">
                  <b style={{ marginTop: '0.15rem' }}>
                    Dynamic Conversation Flow
                  </b>
                  <Switch
                    className="agentswitch custom-switch-primary custom-switch-small ml-2"
                    checked={features?.openAIAssistant?.isEnabled}
                    name="openAIisEnabled"
                    onChange={(e) => handleCheckedOpenAIEnabled(e)}
                  />
                </div>
                <p className="my-2">
                  Conversation flows are useful to provide more detailed,
                  step-by-step instructions to guide a customer through a process or
                  task until completion.
                </p>
                <div className="d-none mt-2">
                  <h5 style={{ marginTop: '0.15rem' }}>Generative ChatGPT</h5>
                  <Switch
                    className="agentswitch custom-switch-primary custom-switch-small ml-2"
                    checked={features.generativeChatGPT}
                    name="generativeChatGPT"
                    onChange={(e) => handleCheckedGenerativeChatGTP(e)}
                  />
                </div>
              </div>
              {features.openAIAssistant !== null &&
                features?.openAIAssistant?.isEnabled === true &&
                formatedProperties !== null && (
                  <Fragment>
                    {/* <Separator className="mb-3 mt-2" /> */}
                    {formatedProperties.length > 1 && (
                      <div className="mb-1 ml-2 ">
                        <h6>Properties</h6>
                        <Input
                          className="border p-2 mb-3"
                          type={formatedProperties.length > 1 ? 'select' : 'text'}
                          name="Property Id"
                          value={
                            formatedProperties.length > 1
                              ? selectedProperty
                              : `${formatedProperties[0].name} (${formatedProperties[0].id})`
                          }
                          onChange={
                            formatedProperties.length > 1 ? handleChange : undefined
                          }
                        >
                          {formatedProperties.length > 1 ? (
                            formatedProperties.map((list, index) => (
                              <option key={index} value={list.id}>
                                {`${list.name} (${list.id})`}
                              </option>
                            ))
                          ) : (
                            <>
                              {`${formatedProperties[0].name} (${formatedProperties[0].id})`}{' '}
                            </>
                          )}
                        </Input>
                      </div>
                    )}
                  </Fragment>
                )}
              {assistantList &&
                assistantList !== null &&
                features.openAIAssistant !== null &&
                features?.openAIAssistant?.isEnabled === true && (
                  <Fragment>
                    {/* <h6>Dynamic Conversation Flow</h6> */}
                    {assistantList.length > 0 ? (
                      <Input
                        className="border p-2 mb-3"
                        type="select"
                        name="assistantId"
                        placeholder="Dynamic Conversation Flow"
                        value={aiAssistant}
                        onChange={handleChangeAssistantId}
                      >
                        <option value="" disabled>
                          Select a Dynamic Conversation Flow
                        </option>
                        {assistantList.map((assist, index) => (
                          <option key={index} value={assist.id}>
                            {assist.isGroupLevel
                              ? `${assist.name} (${assist.id}) (Group Level)`
                              : `${assist.name} (${assist.id})`}
                          </option>
                        ))}
                      </Input>
                    ) : (
                      <Input
                        className="border p-2 mb-3"
                        type="text"
                        name="assistantId"
                        onChange={handleChangeAssistantId}
                        placeholder="Dynamic Conversation Flow"
                        defaultValue={aiAssistant}
                      />
                    )}
                    {/* <Input
                      type="select"
                      name="versionDynamicFlow"
                      value={features.openAIAssistant.versionDynamicFlow}
                      onChange={(e) =>
                        handleVersionDynamicFlowChange(e.target.value)
                      }
                    >
                      <option value="">Select</option>
                      <option value="6DynamicConverstionFlow">
                        Version 6 (with Dynamic Conversation Flow)
                      </option>
                    </Input> */}
                    {aiAssistant && isNavigateToConversationFlow && (
                      <div className="mt-2">
                        <a
                          href={`/app/pages/propinfo/recommender?assistantId=${aiAssistant}`}
                          target="_self"
                          rel="noopener noreferrer"
                          style={{
                            color: 'red',
                            textDecoration: 'underline',
                            fontSize: '15px',
                          }}
                        >
                          Go to conversation flow
                        </a>
                      </div>
                    )}
                    <Separator className='my-3' />
                    <div className="mt-2 d-flex justify-content-center">
                        <Button
                          color="primary"
                          size="xs"
                          outline
                          onClick={handleSave}
                        >
                          Save
                        </Button>
                    </div>
                  </Fragment>
                )}
              {features.generativeGPT3 && (
                <Fragment>
                  {/* <Separator className="mb-3" /> */}
                  {/* <div className="mtl-2 text-center">
                <b>Select Version</b>
                <br />
                <Input
                  className="mt-1"
                  type="select"
                  name="version"
                  value={features.versionGPT3}
                  onChange={(e) => handleVersionGPT3Change(e.target.value)}
                >
                  <option value="1">Version 1 (Retired)</option>
                  <option value="2">Version 2 (Retired)</option>
                  <option value="3">Version 3</option>
                  <option value="5">Version 5</option>
                  <option value="6">Version 6</option>
                </Input>
              </div> */}
                  <div className="mt-2">
                    <b>Select Version</b>
                    <Input
                      type="select"
                      name="version"
                      value={features.versionGPT3}
                      onChange={(e) => handleVersionGPT3Change(e.target.value)}
                      className="mt-1"
                    >
                      <option value="">Select</option>
                      <option value="6">Version 6 (GPT-4o-mini)</option>
                      <option value="7">Version 7 (GPT-5-mini)</option>
                      <option value="AzureGpt4"> Azure OpenAI (gpt-4o-mini)</option>
                    </Input>
                  </div>
                  {features.versionGPT3 === '7' && (
                    <Fragment>
                      {/* <div className="mt-2">
                    <b>Reasoning Efforts</b>
                    <Input
                      type="select"
                      name="reasoningefforts"
                      value={features.reasoningEfforts}
                      onChange={(e) => handleReasoningEffortsChange(e.target.value)}
                      className="mt-1"
                    >
                      <option value="">Select</option>
                      <option value="minimal">Minimal</option>
                      <option value="low">Low</option>
                      <option value="medium">Medium</option>
                      <option value="high">High</option>
                    </Input>
                  </div> */}
                      <div className="mb-2 ml-2 mt-2 mr-2">
                        <b>Verbosity</b>
                        <Input
                          type="select"
                          name="verbosity"
                          value={features.verbosity}
                          onChange={(e) => handleVerbosityChange(e.target.value)}
                          className="mt-1"
                        >
                          <option value="">Select</option>
                          <option value="low">Low</option>
                          <option value="medium">Medium</option>
                          <option value="high">High</option>
                        </Input>
                      </div>
                    </Fragment>
                  )}
                  <div className="mt-3">
                    <b>Choose Languages</b>
                    <br />
                    <Row className="mt-2">
                      {languageGPT3.map((elem, index) => (
                        <Colxx xxs="4">
                          {' '}
                          <CustomInput
                            key={index}
                            type="checkbox"
                            value={elem.code}
                            id={elem.code}
                            onChange={handleLanguageChange}
                            checked={elem.checked}
                            className="text-left"
                          >
                            {elem?.name}
                          </CustomInput>
                        </Colxx>
                      ))}
                    </Row>
                    <Separator className='my-3' />
                    <div className="mt-2 d-flex justify-content-center">
                      <Button
                        color="primary"
                        size="xs"
                        outline
                        onClick={handleSave}
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                </Fragment>
              )}
            </Colxx>
          </Card>
        </CardBody>
      </Card>
    </Fragment>
  );
}
export default Features;
